/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { WindSpeedUnitsEnum } from "./WindSpeedUnitsEnum";
import {
  WindSpeedUnitsEnumFromJSON,
  WindSpeedUnitsEnumFromJSONTyped,
  WindSpeedUnitsEnumToJSON,
  WindSpeedUnitsEnumToJSONTyped,
} from "./WindSpeedUnitsEnum";

/**
 * Mixin for validating "offset" and "duration"
 * Assumes simulation to be present on Serializer
 * @export
 * @interface PatchedConstantWind
 */
export interface PatchedConstantWind {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset?: number;
  /**
   * event duration in seconds. -9999 is the 'infinite duration' value (only allowed in conjunction with infinite simulations
   */
  duration?: number | null;
  /**
   * [time, speed, direction]
   */
  readonly values?: Array<Array<number>>;
  /**
   * wind speed unit (default 'm/s')
   *
   * * `m/s` - meter_per_second
   * * `km/h` - kilometer_per_hour
   */
  units?: WindSpeedUnitsEnum;
  /**
   * interpolate wind speed
   */
  readonly speedInterpolate?: boolean;
  /**
   * constant wind speed
   */
  readonly speedConstant?: boolean;
  /**
   * interpolate wind direction
   */
  readonly directionInterpolate?: boolean;
  /**
   * constant wind direction
   */
  readonly directionConstant?: boolean;
  /**
   * constant wind speed
   */
  speedValue?: number;
  /**
   * constant wind direction in degrees (0-360) from north - meteorological standard (thus, 180 is a southern wind)
   */
  directionValue?: number;
}

/**
 * Check if a given object implements the PatchedConstantWind interface.
 */
export function instanceOfPatchedConstantWind(value: object): value is PatchedConstantWind {
  return true;
}

export function PatchedConstantWindFromJSON(json: any): PatchedConstantWind {
  return PatchedConstantWindFromJSONTyped(json, false);
}

export function PatchedConstantWindFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedConstantWind {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    uid: json["uid"] == null ? undefined : json["uid"],
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    offset: json["offset"] == null ? undefined : json["offset"],
    duration:
      json["duration"] === undefined
        ? undefined
        : json["duration"] === null
        ? null
        : json["duration"],
    values: json["values"] == null ? undefined : json["values"],
    units: json["units"] == null ? undefined : WindSpeedUnitsEnumFromJSON(json["units"]),
    speedInterpolate: json["speed_interpolate"] == null ? undefined : json["speed_interpolate"],
    speedConstant: json["speed_constant"] == null ? undefined : json["speed_constant"],
    directionInterpolate:
      json["direction_interpolate"] == null ? undefined : json["direction_interpolate"],
    directionConstant: json["direction_constant"] == null ? undefined : json["direction_constant"],
    speedValue: json["speed_value"] == null ? undefined : json["speed_value"],
    directionValue: json["direction_value"] == null ? undefined : json["direction_value"],
  };
}

export function PatchedConstantWindToJSON(json: any): PatchedConstantWind {
  return PatchedConstantWindToJSONTyped(json, false);
}

export function PatchedConstantWindToJSONTyped(
  value?: Omit<
    PatchedConstantWind,
    | "id"
    | "uid"
    | "url"
    | "simulation"
    | "values"
    | "speedInterpolate"
    | "speedConstant"
    | "directionInterpolate"
    | "directionConstant"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value["offset"],
    duration: value["duration"],
    units: WindSpeedUnitsEnumToJSON(value["units"]),
    speed_value: value["speedValue"],
    direction_value: value["directionValue"],
  };
}
